(function(){
'use strict';
var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function initLab(root){
  (root||document).querySelectorAll('[data-rs31-lab]').forEach(function(lab){
    if(lab.dataset.rs31Bound==='1')return;
    lab.dataset.rs31Bound='1';
    var tabs=Array.prototype.slice.call(lab.querySelectorAll('[data-rs31-tab]'));
    var panels=Array.prototype.slice.call(lab.querySelectorAll('[data-rs31-panel]'));
    function select(index,focus){
      tabs.forEach(function(tab,i){
        var active=i===index;
        tab.setAttribute('aria-selected',active?'true':'false');
        tab.tabIndex=active?0:-1;
        if(active&&focus)tab.focus();
      });
      panels.forEach(function(panel,i){panel.hidden=i!==index});
    }
    tabs.forEach(function(tab,i){
      tab.addEventListener('click',function(){select(i,false)});
      tab.addEventListener('keydown',function(e){
        var next;
        if(e.key==='ArrowRight'||e.key==='ArrowDown')next=(i+1)%tabs.length;
        if(e.key==='ArrowLeft'||e.key==='ArrowUp')next=(i-1+tabs.length)%tabs.length;
        if(e.key==='Home')next=0;
        if(e.key==='End')next=tabs.length-1;
        if(next!==undefined){e.preventDefault();select(next,true)}
      });
    });
    lab.querySelectorAll('[data-rs31-flip]').forEach(function(button){
      button.addEventListener('click',function(){
        var visual=button.closest('[data-rs31-visual]');
        if(!visual)return;
        var flipped=visual.getAttribute('data-rs31-side')!=='back';
        visual.setAttribute('data-rs31-side',flipped?'back':'front');
        button.setAttribute('aria-pressed',flipped?'true':'false');
        button.setAttribute('aria-label',flipped?'Volver a la fotografía principal':'Mostrar otra fotografía del producto');
        var label=button.querySelector('[data-rs31-flip-label]');
        if(label)label.textContent=flipped?'PRIMERA VISTA':'OTRA VISTA';
      });
    });
  });
}
function initPointer(root){
  if(reduce||!window.matchMedia('(hover: hover) and (pointer: fine)').matches)return;
  (root||document).querySelectorAll('.rs26-shop__card,.rs26-look__tile').forEach(function(card){
    if(card.dataset.rs31Pointer==='1')return;
    card.dataset.rs31Pointer='1';
    var box=null,frame=0,lastEvent=null;
    card.addEventListener('pointerenter',function(){box=card.getBoundingClientRect()});
    card.addEventListener('pointermove',function(e){
      if(!box)return;
      lastEvent=e;
      if(frame)return;
      frame=window.requestAnimationFrame(function(){
        frame=0;
        if(!lastEvent||!box)return;
        var x=(lastEvent.clientX-box.left)/box.width-.5;
        var y=(lastEvent.clientY-box.top)/box.height-.5;
        card.style.setProperty('--rs31-tilt-y',(-x*4).toFixed(2)+'deg');
        card.style.setProperty('--rs31-tilt-x',(y*4).toFixed(2)+'deg');
        card.style.setProperty('--rs31-pointer-x',((x+.5)*100).toFixed(1)+'%');
        card.style.setProperty('--rs31-pointer-y',((y+.5)*100).toFixed(1)+'%');
      });
    },{passive:true});
    card.addEventListener('pointerleave',function(){
      if(frame)window.cancelAnimationFrame(frame);
      frame=0;lastEvent=null;box=null;
      card.style.removeProperty('--rs31-tilt-x');
      card.style.removeProperty('--rs31-tilt-y');
      card.style.removeProperty('--rs31-pointer-x');
      card.style.removeProperty('--rs31-pointer-y');
    });
  });
  (root||document).querySelectorAll('.rs26-hero').forEach(function(hero){
    if(hero.dataset.rs31Pointer==='1')return;
    hero.dataset.rs31Pointer='1';
    var frame=0,pos=null;
    hero.addEventListener('pointermove',function(e){
      pos={x:(e.clientX/window.innerWidth)*100,y:(e.clientY/window.innerHeight)*100};
      if(frame)return;
      frame=window.requestAnimationFrame(function(){
        frame=0;if(!pos)return;
        hero.style.setProperty('--rs31-hero-x',pos.x.toFixed(1)+'%');
        hero.style.setProperty('--rs31-hero-y',pos.y.toFixed(1)+'%');
      });
    },{passive:true});
    hero.addEventListener('pointerleave',function(){
      if(frame)window.cancelAnimationFrame(frame);frame=0;pos=null;
      hero.style.removeProperty('--rs31-hero-x');
      hero.style.removeProperty('--rs31-hero-y');
    });
  });
}
var revealObserver;
function initReveals(root){
  if(reduce||!('IntersectionObserver' in window))return;
  if(!revealObserver){
    revealObserver=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting)return;
        entry.target.classList.add('rs31-inview');
        revealObserver.unobserve(entry.target);
      });
    },{rootMargin:'0px 0px -6% 0px',threshold:.08});
  }
  (root||document).querySelectorAll('.rs31-lab__heading,.rs26-shop__card,.rs26-drop__visual,.rs26-look__heading,.rs26-story__visual').forEach(function(el){
    if(el.dataset.rs31Reveal==='1')return;
    el.dataset.rs31Reveal='1';
    el.classList.add('rs31-animatable');
    revealObserver.observe(el);
  });
}
function init(root){initLab(root);initPointer(root);initReveals(root)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});
else init(document);
document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();